(() => {
  function initialize(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const cards = [...root.querySelectorAll('[data-product-card]')];
    if (!cards.length) return;
    const strings = JSON.parse(root.querySelector('[data-strings]').textContent);
    const canOrder = root.dataset.canOrder === 'true';
    const format = new Intl.NumberFormat(root.dataset.locale || 'en', {
      style: 'currency', currency: root.dataset.currency || 'EGP'
    });
    const money = value => format.format(value / 100);
    const variants = new Map();
    const quantities = new Map();
    const existing = new Map();
    const combinedTiers = root.dataset.combinedTiers === 'true';
    let cartCount = 0;
    const review = root.querySelector('[data-review]');
    const status = root.querySelector('[data-status]');
    let ready = false;
    let submitting = false;
    let locked = false;
    const say = message => { status.textContent = message; };
    const active = card => variants.get(card.querySelector('[data-variant-select]').value);
    const quantity = id => quantities.get(String(id)) || 0;
    const defaultEight = root.dataset.caseEight === 'true';
    const inCart = id => existing.get(String(id)) || 0;
    const combinedCount = () => cartCount + [...quantities.values()].reduce((sum, q) => sum + q, 0);
    const discountRate = () => {
      const count = combinedCount();
      return count >= 48 ? 0.20 : count >= 24 ? 0.15 : count >= 8 ? 0.10 : 0;
    };
    const unitPrice = variant => {
      if (combinedTiers) return Math.round(variant.price * (1 - discountRate()));
      const totalQuantity = quantity(variant.id) + inCart(variant.id);
      return variant.breaks.reduce((price, tier) => totalQuantity >= tier.min ? tier.price : price, variant.price);
    };
    function updateCard(card) {
      const variant = active(card);
      if (!variant) return;
      const q = quantity(variant.id);
      const base = inCart(variant.id);
      const increment = Math.max(1, variant.step || 1);
      const minimum = Math.max(1, variant.min || 1);
      const maximum = Number.isFinite(variant.max) ? variant.max : Infinity;
      const firstAddition = Math.max(increment, minimum - base);
      let next = q === 0 && !defaultEight ? firstAddition : (q || 8) + increment;
      if ((base + next) % increment) next += increment - ((base + next) % increment);
      const disabled = !ready || !canOrder || submitting || locked || !variant.available || variant.requiresSellingPlan;
      card.dataset.selected = String(q > 0);
      const displayed = q || (defaultEight ? 8 : 0);
      card.querySelector('[data-quantity]').textContent = displayed;
      card.querySelector('[data-step="-1"]').disabled = disabled || (defaultEight ? displayed <= 8 : q === 0);
      card.querySelector('[data-step="1"]').disabled = disabled || base + next > maximum;
      card.querySelector('[data-variant-select]').disabled = submitting || locked;
      const choose = card.querySelector('[data-choose]');
      if (choose) {
        choose.disabled = disabled || base + displayed > maximum;
        choose.textContent = q ? strings.removeSelection : strings.choose;
        choose.setAttribute('aria-pressed', String(q > 0));
      }
      card.querySelector('[data-unit-price]').textContent = `${money(unitPrice(variant))} / ${strings.unit}`;
      const preview = card.querySelector('[data-pack-preview]');
      if (preview) {
        const previewCount = combinedCount() + (q ? 0 : displayed);
        const rate = combinedTiers ? (previewCount >= 48 ? .20 : previewCount >= 24 ? .15 : previewCount >= 8 ? .10 : 0) : 0;
        const previewUnit = combinedTiers ? Math.round(variant.price * (1 - rate)) : unitPrice(variant);
        const original = card.querySelector('[data-pack-original]');
        original.textContent = money(variant.price * displayed);
        original.hidden = previewUnit >= variant.price;
        card.querySelector('[data-pack-total]').textContent = money(previewUnit * displayed);
        card.querySelector('[data-pack-label]').textContent = strings.packTotal.replace('__quantity__', displayed);
        card.querySelector('[data-pack-discount]').textContent = rate ? Math.round(rate * 100) + '% ' + strings.discount : '';
      }
      const ruleText = [`${strings.minimum} ${minimum}`, `${strings.increment} ${increment}`];
      if (Number.isFinite(maximum)) ruleText.push(`${strings.maximum} ${maximum}`);
      if (!variant.available) ruleText.push(strings.soldOut);
      card.querySelector('[data-rules]').textContent = ruleText.join(' · ');
      card.querySelector('[data-volume]').textContent = variant.breaks.map(tier => `${tier.min}+ : ${money(tier.price)} / ${strings.unit}`).join(' · ');
    }
    function update() {
      const lines = root.querySelector('[data-lines]');
      lines.replaceChildren();
      let count = 0;
      let subtotal = 0;
      for (const [id, q] of quantities) {
        if (!q) continue;
        const variant = variants.get(id);
        const cost = unitPrice(variant) * q;
        count += q;
        subtotal += cost;
        const line = document.createElement('div');
        line.className = 'cp-cartline';
        const title = document.createElement('span');
        title.textContent = variant.productTitle;
        const detail = document.createElement('span');
        detail.className = 'cp-small';
        detail.textContent = `${variant.title === 'Default Title' ? '' : variant.title + ' · '}${q} ${q === 1 ? strings.unit : strings.units}`;
        title.append(document.createElement('br'), detail);
        const amount = document.createElement('span');
        amount.textContent = money(cost);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cp-remove-line';
        remove.dataset.removeVariant = id;
        remove.setAttribute('aria-label', `${strings.remove || 'Remove'} ${variant.productTitle} ${variant.title}`);
        remove.textContent = '×';
        remove.disabled = submitting || locked;
        line.append(title, amount, remove);
        lines.append(line);
      }
      if (!count) {
        const empty = document.createElement('p');
        empty.className = 'cp-small';
        empty.textContent = strings.empty;
        lines.append(empty);
      }
      root.querySelector('[data-count]').textContent = count;
      root.querySelector('[data-total]').textContent = money(subtotal);
      const tierStatus = root.querySelector('[data-tier-status]');
      if (tierStatus && combinedTiers) tierStatus.textContent = `${combinedCount()} ${strings.units} · ${Math.round(discountRate() * 100)}% ${strings.discount || 'off'}`;
      review.disabled = !count || !ready || !canOrder || submitting || locked;
      cards.forEach(updateCard);
    }
    for (const card of cards) {
      const product = JSON.parse(card.querySelector('[data-product-json]').textContent);
      for (const variant of product.variants) {
        variant.id = String(variant.id);
        variant.productTitle = product.title;
        if (root.dataset.caseEight === 'true') {
          variant.min = 8;
          variant.step = 1;
        }
        variant.breaks = (variant.breaks || []).sort((a, b) => a.min - b.min);
        variants.set(variant.id, variant);
      }
      card.querySelector('[data-variant-select]').addEventListener('change', () => updateCard(card));
    }
    root.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || button.disabled || !root.contains(button)) return;
      if (button.dataset.filter) {
        const filter = button.dataset.filter;
        root.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => { card.hidden = filter !== 'all' && card.dataset.category !== filter; });
        root.querySelector('[data-empty-filter]').hidden = cards.some(card => !card.hidden);
        return;
      }
      if (!canOrder || !ready || submitting || locked) return;
      if (button.hasAttribute('data-choose')) {
        const variant = active(button.closest('[data-product-card]'));
        if (!variant || !variant.available || variant.requiresSellingPlan) return;
        if (quantity(variant.id)) quantities.delete(variant.id);
        else quantities.set(variant.id, Math.max(8, variant.min || 1));
        update();
        say(strings.edited);
        return;
      }
      if (button.dataset.removeVariant) {
        quantities.delete(button.dataset.removeVariant);
        update();
        say(strings.edited);
        return;
      }
      if (button.dataset.step) {
        const card = button.closest('[data-product-card]');
        const variant = active(card);
        if (!variant || !variant.available || variant.requiresSellingPlan) return;
        const id = variant.id;
        const old = quantity(id) || (defaultEight ? 8 : 0);
        const base = inCart(id);
        const min = Math.max(1, variant.min || 1);
        const step = Math.max(1, variant.step || 1);
        const max = Number.isFinite(variant.max) ? variant.max : Infinity;
        let next;
        if (Number(button.dataset.step) > 0) {
          next = old === 0 ? Math.max(step, min - base) : old + step;
          if ((base + next) % step) next += step - ((base + next) % step);
          if (base + next > max) return;
        } else {
          next = old - step;
          if (defaultEight) next = Math.max(8, next);
          else if (next < 0 || base + next < min) next = 0;
        }
        quantities.set(id, next);
        update();
        say(strings.edited);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && card.animate) {
          card.animate([{ transform: 'translateY(-2px)' }, { transform: 'translateY(0)' }], { duration: 180 });
        }
      }
    });
    review.addEventListener('click', async () => {
      if (!canOrder || !ready || submitting || locked) return;
      const items = [...quantities].filter(([, q]) => q > 0).map(([id, q]) => ({ id: Number(id), quantity: q }));
      if (!items.length) return;
      submitting = true;
      root.setAttribute('aria-busy', 'true');
      update();
      say(strings.adding);
      let sent = false;
      try {
        const currentResponse = await fetch(root.dataset.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
        if (!currentResponse.ok) throw new Error(strings.cartError);
        const currentCart = await currentResponse.json();
        cartCount = currentCart.items.reduce((sum, item) => sum + item.quantity, 0);
        existing.clear();
        for (const item of currentCart.items) existing.set(String(item.variant_id), inCart(item.variant_id) + item.quantity);
        for (const item of items) {
          const variant = variants.get(String(item.id));
          const finalQuantity = inCart(item.id) + item.quantity;
          if (finalQuantity < variant.min || finalQuantity % variant.step !== 0 || (Number.isFinite(variant.max) && finalQuantity > variant.max)) throw new Error(strings.minimumError);
        }
        sent = true;
        const response = await fetch(root.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }), signal: AbortSignal.timeout(20000)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : strings.error);
        locked = true;
        quantities.clear();
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        locked = sent;
        say(sent ? `${error.message && error.name !== 'TimeoutError' ? error.message + ' ' : ''}${strings.uncertain}` : strings.cartError);
      } finally {
        submitting = false;
        root.removeAttribute('aria-busy');
        update();
      }
    });
    update();
    if (!canOrder) return;
    say(strings.loading);
    fetch(root.dataset.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) })
      .then(response => { if (!response.ok) throw new Error(); return response.json(); })
      .then(cart => {
        if (cart.currency && cart.currency !== root.dataset.currency) throw new Error();
        cartCount = cart.items.reduce((sum, item) => sum + item.quantity, 0);
        for (const item of cart.items) existing.set(String(item.variant_id), inCart(item.variant_id) + item.quantity);
        ready = true;
        say('');
        update();
      })
      .catch(() => { say(strings.cartError); });
  }
  document.querySelectorAll('[data-sc-wholesale]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('[data-sc-wholesale]')));
})();
